import { Routes } from '@angular/router';
import { PaymentGatewayComponent } from './payment-gateway/payment-gateway.component';
import { DealCancelationComponent } from './deal-cancelation/deal-cancelation.component';
import { CampaignComponent } from './campaign/campaign.component';
import { PaymentPreviewComponent } from './payment-preview/payment-preview.component';

export const routes: Routes = [
    { path: 'preview/:ref', component: PaymentPreviewComponent },
    { path: 'pay/:ref', component: PaymentGatewayComponent },
    { path: 'cancel/:ref', component: DealCancelationComponent },
    { path: 'campaigns/:lang/:cId/:rId', component: CampaignComponent },
];
